import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';

import AiAgentsPageRouteView from './pages/AiAgentsPageRouteView.vue';
import RosterIndex from './roster/Index.vue';
import BrainTab from './agent/BrainTab.vue';
import ModelTab from './agent/ModelTab.vue';
import SkillsTab from './agent/SkillsTab.vue';
import ToolsTab from './agent/ToolsTab.vue';
import VoiceTab from './agent/VoiceTab.vue';
import VersionsTab from './agent/VersionsTab.vue';
import TicketsTab from './agent/TicketsTab.vue';
import LiveTab from './agent/LiveTab.vue';
import FlowTab from './agent/flow/FlowTab.vue';

// D35: clone of the Captain routing pattern (never extends Captain).
// Double gating: the feature flag lives here; hook presence is enforced in
// the roster page ("enable the integration first") and the sidebar entry.
const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.AI_AGENTS,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-agents'),
    component: AiAgentsPageRouteView,
    children: [
      {
        path: '',
        name: 'ai_agents_index',
        component: RosterIndex,
        meta,
      },
      {
        path: ':brainId',
        name: 'ai_agents_agent_show',
        redirect: to => ({
          name: 'ai_agents_agent_brain',
          params: to.params,
        }),
      },
      {
        path: ':brainId/brain',
        name: 'ai_agents_agent_brain',
        component: BrainTab,
        meta,
      },
      {
        path: ':brainId/model',
        name: 'ai_agents_agent_model',
        component: ModelTab,
        meta,
      },
      {
        path: ':brainId/skills',
        name: 'ai_agents_agent_skills',
        component: SkillsTab,
        meta,
      },
      {
        path: ':brainId/tools',
        name: 'ai_agents_agent_tools',
        component: ToolsTab,
        meta,
      },
      {
        path: ':brainId/voice',
        name: 'ai_agents_agent_voice',
        component: VoiceTab,
        meta,
      },
      {
        path: ':brainId/tickets',
        name: 'ai_agents_agent_tickets',
        component: TicketsTab,
        meta,
      },
      {
        path: ':brainId/versions',
        name: 'ai_agents_agent_versions',
        component: VersionsTab,
        meta,
      },
      {
        path: ':brainId/flow',
        name: 'ai_agents_agent_flow',
        component: FlowTab,
        meta,
      },
      {
        path: ':brainId/live',
        name: 'ai_agents_agent_live',
        component: LiveTab,
        meta,
      },
    ],
  },
];
